 
import _ from 'underscore'
import service from '../service/cart'
import CONSTANT from '../constant/cart'
import { isLogged } from '../util/function'
import localStorage from 'localStorage'
// import dayjs from '@app/js/lib/dayjs'

const getCartTotal = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    const list = JSON.parse(localStorage.getItem(CONSTANT.CART_LOCAL_STORAGE_LIST)) || []
    let number = 0
      _.each(list, (v) => {
        number += v.count
      })
    if (!isLogged()) {
      commit(CONSTANT.CART_GET_TOTAL_SUCCESS, number)
      return resolve(number)
    }
    return service.getCartTotal().then(data => {
      if (_.isEmpty(data)) {
        resolve(0)
        commit(CONSTANT.CART_GET_TOTAL_ERROR_EMPTY)
        return 0
      }
      const len = data.total + number
      resolve(len)
      commit(CONSTANT.CART_GET_TOTAL_SUCCESS, len)
      return len
    }, e => {
      reject(e)
      commit(CONSTANT.CART_GET_TOTAL_ERROR, e)
    })
  })
}

const getCartTotalAgain = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    return service.getCartTotal().then(data => {
      if (_.isEmpty(data)) {
        resolve(0)
        commit(CONSTANT.CART_GET_TOTAL_ERROR_EMPTY)
        return 0
      }
      resolve(data.total)
      commit(CONSTANT.CART_GET_TOTAL_SUCCESS, data.total)
      return data.total
    }, e => {
      reject(e)
      commit(CONSTANT.CART_GET_TOTAL_ERROR, e)
    })
  })
}


const getCartSku = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    return service.getCartSku().then(data => {
      if (_.isEmpty(data)) {
        resolve([])
        commit(CONSTANT.CART_GET_SKU_ERROR_EMPTY)
        return []
      }
      _.each(data || [], (v, key, list) => {
        v.selected = _.contains(state.selectedSku, "" + v.skuId)

        // 购物车商品默认勾选最近120小时加入的商品
        // const isUnder120H = v.sku.joinTime && dayjs().diff(dayjs.unix(v.sku.joinTime), 'hours') < 120
        // if (isUnder120H) {
        //   v.selected = true
        // }
      })
      resolve(data)
      commit(CONSTANT.CART_GET_SKU_SUCCESS, data)
      return data
    }, e => {
      reject(e)
      commit(CONSTANT.CART_GET_SKU_ERROR, e)
    })
  })
}

const selectCartSku = ({ commit, state }, options) => {
  return new Promise((resolve, reject) => {
    return service.selectCartSku(options).then(data => {
      resolve(data)
      commit('selectCartSku', data)
      return data
    }, e => {
      reject(e)
    })
  })
}

const deleteCartSku = ({ commit, state }, options) => {
  return new Promise((resolve, reject) => {
    return service.deleteCartSku(options).then(data => {
      resolve(data)
    commit(CONSTANT.CART_DELETE_SKU_SUCCESS, options)
      return data
    }, e => {
      reject(e)
    })
  })
}

const addSkuCount = ({ commit, state }, item) => {
  const options = {
    skuList: [{
      "skuId": item.skuId,
      "count": item.count + 1
    }]
  }
  return new Promise((resolve, reject) => {
    return service.updateSku(options).then(data => {
      resolve()
      commit('addSkuCount', item)
      return
    }, e => {
      reject(e)
    })
  })
}

const inputSkuCount = ({ commit, state}, item) => {
  const options = {
    skuList: item
  }
  return new Promise((resolve, reject) => {
    return service.updateSku(options).then(data => {
      resolve()
      commit('inputSkuCount', item)
      return
    }, e => {
      commit('inputSkuCount', item )
      reject(e)
    }).then(res => {

    })
  })
}

const subSkuCount = ({ commit, state }, item) => {
  const options = {
    skuList: [{
      "skuId": item.skuId,
      "count": item.count - 1
    }]
  }
  return new Promise((resolve, reject) => {
    return service.updateSku(options).then(data => {
      resolve()
      commit('subSkuCount', item)
      return
    }, e => {
      reject(e)
    })
  })
}

const addSkuToCart = ({ commit, state }, options) => {
  return new Promise((resolve, reject) => {
    return service.addSku(options).then(data => {
      resolve()
      commit('addSkutoCartSuccess', options)
      return
    }, e => {

      reject(e)
    })
  })
}

const getSkuById = ({ commit, state }, item) => {
  const options = {
    skuList: item,
  }
  return new Promise((resolve, reject) => {
    return service.getSkuById(options).then(data => {
      if (_.isEmpty(data)) {
        commit(CONSTANT.SKU_GET_DETAIL_BY_ID_ERROR_EMPTY)
        // return resolve({})
      }
      resolve(data)
      commit(CONSTANT.SKU_GET_DETAIL_BY_ID_SUCCESS, data)
      return data
    }, e => {
      reject(e)
      commit(CONSTANT.SKU_GET_DETAIL_BY_ID_ERROR, e)
    })
  })
}

const verifyCart = ({ commit }, options) => {
  return new Promise((resolve, reject) => {
    return service.verifyCart(options).then(data => {
      return resolve(data)
    }, e => {
      reject(e)
    })
  })
}

const getTyingProductPriceSection = ({commit}, options) => {
  return new Promise((resolve, reject) => {
    return service.getTyingProductPriceSection(options).then(data => {
      return resolve(data)
    }, e => {
      reject(e)
    })
  })
}

const getTyingProducts = ({
  commit,
}, options) => {
  return new Promise((resolve, reject) => {
    return service.getTyingProducts(options).then(data => {
      return resolve(data)
    }, e => {
      reject(e)
    })
  })
}

const getCartExpressFeeTip = ({
  commit,
}, options) => {
  return new Promise((resolve, reject) => {
    return service.getCartExpressFeeTip(options).then(data => {
      return resolve(data)
    }, e => {
      reject(e)
    })
  })
}

export default {
  getCartTotal,
  getCartTotalAgain,
  getCartSku,
  deleteCartSku,
  inputSkuCount,
  addSkuCount,
  subSkuCount,
  addSkuToCart,
  getSkuById,
  verifyCart,
  // selectSku,
  getTyingProductPriceSection,
  getTyingProducts,
  getCartExpressFeeTip,
  selectCartSku,
}
